import React, { useState } from 'react';

export default function useBubbleVisible() {
  const [visible, setVisible] = useState(false);

  const handleMouseEnter = (e?: React.MouseEvent<HTMLDivElement>) => {
    e?.stopPropagation();

    if (visible) {
      return;
    }

    setVisible(true);
  };

  const handleMouseLeave = (e?: React.MouseEvent<HTMLDivElement>) => {
    e?.stopPropagation();

    if (visible) {
      setVisible(false);
    }
  };

  const handleMouseMove = (e?: React.MouseEvent<HTMLDivElement>) => {
    e?.stopPropagation();
    e?.preventDefault();
  };

  return { visible, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onMouseMove: handleMouseMove };
}
